import { render, staticRenderFns } from "./ArtworkCompetition.vue?vue&type=template&id=b39bb262&scoped=true"
import script from "./ArtworkCompetition.vue?vue&type=script&lang=js"
export * from "./ArtworkCompetition.vue?vue&type=script&lang=js"
import style0 from "./ArtworkCompetition.vue?vue&type=style&index=0&id=b39bb262&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b39bb262",
  null
  
)

export default component.exports